import { render, staticRenderFns } from "./CourseAddModal.vue?vue&type=template&id=23681a0b&"
import script from "./CourseAddModal.vue?vue&type=script&lang=js&"
export * from "./CourseAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports